import React from 'react'

export function renderOverview(ctx) {
  const {
    activeProjects,
    activeTab,
    activeWorkers,
    chatSessions,
    navigate,
    projects,
    sales,
    t,
    totalSales,
    unreadCount,
    workers,
  } = ctx
  return (
    <>
          {activeTab === 'overview' && (
            <div className="dash-section">
              <div className="dash-section-header"><h2>{t.dashboardOverview}</h2><p>{t.welcomeBack}</p></div>
              <div className="dash-stats-grid">
                <div className="dash-stat-card"><div className="dash-stat-icon blue">👥</div><div><p className="dash-stat-label">{t.activeWorkers}</p><p className="dash-stat-value">{activeWorkers}</p><p className="dash-stat-sub">{workers.length} {t.total}</p></div></div>
                <div className="dash-stat-card"><div className="dash-stat-icon green">📋</div><div><p className="dash-stat-label">{t.activeProjects}</p><p className="dash-stat-value">{activeProjects}</p><p className="dash-stat-sub">{projects.length} {t.total}</p></div></div>
                <div className="dash-stat-card"><div className="dash-stat-icon orange">💼</div><div><p className="dash-stat-label">{t.totalSales}</p><p className="dash-stat-value">${totalSales.toLocaleString()}</p><p className="dash-stat-sub">{sales.length} {t.records}</p></div></div>
                <div className="dash-stat-card"><div className="dash-stat-icon purple">💬</div><div><p className="dash-stat-label">{t.chatMessages}</p><p className="dash-stat-value">{chatSessions.reduce((n, s) => n + (s.messageCount || 0), 0)}</p><p className="dash-stat-sub">{unreadCount} {t.unread}</p></div></div>
              </div>
              <div className="dash-overview-grid">
                <div className="dash-overview-card">
                  <h3>{t.activeProjects}</h3>
                  {projects.length === 0 ? <p className="dash-empty-msg">{t.noProjects}</p> : (
                    <ul className="dash-overview-list">
                      {projects.slice(-5).reverse().map(p => (
                        <li key={p.id} className="dash-overview-item">
                          <span className="dash-overview-avatar training">{p.rubric?.[0]}</span>
                          <span className="dash-overview-name">{p.title}</span>
                          <div className="dash-mini-progress"><div className="dash-mini-progress-bar" style={{ width: `${p.progress || 0}%` }} /></div>
                          <span className={`dash-cat-badge ${p.status}`}>{p.status}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <button className="dash-overview-btn" onClick={() => navigate('projects')}>{t.manageProjects}</button>
                </div>
                <div className="dash-overview-card">
                  <h3>{t.recentSales}</h3>
                  {sales.length === 0 ? <p className="dash-empty-msg">{t.noProjects}</p> : (
                    <ul className="dash-overview-list">
                      {sales.slice(-5).reverse().map(s => (
                        <li key={s.id} className="dash-overview-item">
                          <span className="dash-overview-avatar">{s.client?.[0]?.toUpperCase()}</span>
                          <span className="dash-overview-name">{s.client}</span>
                          <span className="dash-overview-role">{s.amount}</span>
                          <span className={`dash-sale-badge ${s.status}`}>{s.status}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    <button className="dash-overview-btn" onClick={() => navigate('quotes')}>{t.quotes} →</button>
                    <button className="dash-overview-btn" onClick={() => navigate('invoices')}>{t.invoices || 'Invoices'} →</button>
                    <button className="dash-overview-btn" onClick={() => navigate('sell')}>{t.manageSales}</button>
                  </div>
                </div>
              </div>
            </div>
          )}
    </>
  )
}
